var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.0352,
    cy: 23,
    rx: 23.0189,
    ry: 23,
    fill: "#0C2780"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_312_5642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8475 18.2631C27.727 17.9223 27.5038 17.6271 27.2087 17.4183C26.9135 17.2094 26.561 17.0972 26.1994 17.0969H24.8446C24.4611 17.099 24.0918 17.2421 23.8071 17.4991C23.5224 17.7561 23.3424 18.1089 23.3012 18.4901C23.2601 18.8714 23.3608 19.2545 23.5841 19.5663C23.8074 19.8781 24.1376 20.0967 24.5119 20.1805L26.5733 20.6315C26.9939 20.7244 27.3655 20.9693 27.6168 21.3192C27.8682 21.6691 27.9815 22.0994 27.9352 22.5277C27.8889 22.956 27.6862 23.3522 27.3659 23.6403C27.0456 23.9284 26.6302 24.0881 26.1994 24.089H25.0332C24.6717 24.0887 24.3191 23.9765 24.0239 23.7676C23.7288 23.5588 23.5056 23.2636 23.3851 22.9228M25.6163 17.0969V15.3477M25.6163 25.8365V24.0872",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0935 21.5143C12.246 23.0756 11.9162 24.8656 12.1517 26.6264C12.3871 28.3872 13.1756 30.0278 14.4035 31.3116C15.6314 32.5954 17.2353 33.4561 18.9838 33.7696C20.7324 34.0832 22.5354 33.8333 24.1328 33.0561M17.2283 20.595C17.2283 22.8197 18.112 24.9532 19.6851 26.5263C21.2582 28.0993 23.3917 28.983 25.6163 28.983C27.8409 28.983 29.9745 28.0993 31.5475 26.5263C33.1206 24.9532 34.0043 22.8197 34.0043 20.595C34.0043 18.3704 33.1206 16.2369 31.5475 14.6638C29.9745 13.0908 27.8409 12.207 25.6163 12.207C23.3917 12.207 21.2582 13.0908 19.6851 14.6638C18.112 16.2369 17.2283 18.3704 17.2283 20.595Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_312_5642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0098,
    height: 24.0098,
    fill: "white",
    transform: "translate(11.0303 10.9961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon_01.48190650030d69e78891cbb50eddebb7.svg";
export { ForwardRef as ReactComponent };